import React, {createRef, useEffect, useState} from 'react';
import ContentWrapper from './ContentWrapper';
import ClientSection from './ClientSection';
import { Link } from 'gatsby';
import Section from './Section';
import TeamIllustration from '../images/TeamIllustration.svg';
import Heisann from '../images/titles/heisann.svg';
import VideoFrame from '../images/Ramme.svg';
import PlayIcon from '../images/PlayIcon.svg';
import VimeoPlayer from '@vimeo/player';
import ArrowDown from '../images/arrow_down.svg';
import { StaticImage } from 'gatsby-plugin-image';
import { ACTIVE_YEARS } from '../data/archive';
import { useT, LocalizedLink } from '../i18n';

const Hero = () => {
    const t = useT();
    const videoIframe = createRef();
    let videoPlayer = createRef().current;
    const [playVideo, setPlayVideo] = useState(false);

    useEffect(() => {
        if(videoIframe.current) {
            videoPlayer = new VimeoPlayer(videoIframe.current);
        }
    }, [videoIframe])

    const playOrPauseVideo = () => {
        setPlayVideo(!playVideo);
    }

    useEffect(async () => {
        if(videoIframe.current && videoPlayer) {
            if(playVideo) {
                videoPlayer.play().then(() => {
                   console.log("Playing video")
                }).catch(ex => {
                    console.error(ex);
                });
                /*
                videoPlayer.setVolume(0.6).then(() => {
                    console.log("Set volume");
                }).catch(ex => {
                    console.error(ex);
                });
                */
            } else {
                videoPlayer.pause().then().catch(ex => {
                    console.error(ex);
                });
            }
        }
    }, [playVideo])


    useEffect(() => {
        window.addEventListener('scroll', hideArrowButtonOnScroll);
        return () => {
            window.removeEventListener('scroll', hideArrowButtonOnScroll);
        }
    }, [])

    

    const hideArrowButtonOnScroll = () => {
        if(window.scrollY > 0) {
            document.getElementById("scroll_down_button").style.display = "none";
        }
    }

    const scrollToMainSection = () => {
        const yOffset = -100; 
        const element = document.getElementById("main_section");
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    }

    return <>
    <div className="video-responsive z-0">
        <img src={ArrowDown} id="scroll_down_button" onClick={scrollToMainSection} className="cursor-pointer hidden lg:block scroll-down-button absolute left-2/4 z-50 bottom-60" />
        <iframe src="https://player.vimeo.com/video/708980610?autoplay=1&muted=1&loop=1&title=0&controls=0" allow="autoplay" width="640" height="360" className="sm:height-auto md:mb-32 mx-auto" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
        <div className="video-responsive-overlay flex  items-center">     

            <div className='max-w-md px-8 md:px-24 md:mt-0'>
                <p className="md:hero-text text-white mt-4 font-bold text-xl lg:text-2xl ">
                {t('Produksjonsselskap med fokus på håndtegnet 2D-animasjon', 'Production company focused on hand-drawn 2D animation')}, {ACTIVE_YEARS}
                </p>
                <Link to="https://vimeo.com/708980610" target="_blank" className="w-full flex ">
                    <div className="mt-8 flex  rounded-md border-transparent  text-white items-center justify-center bg-tb-dark cursor-pointer showreel-button">Showreel</div>
                </Link>
            </div>
        </div> 
        
    </div>
    <div  id="main_section">
    <div className='px-8 lg:px-16' >
        <ContentWrapper>
            <div className="mt-8 md:mt-16 mx-auto max-w-3xl bg-tb-yellow text-tb-dark rounded-md px-6 py-8 md:px-12 text-center">
                <p className="text-2xl md:text-3xl font-bold mb-4">
                    {t('Åpne for nye jobber og oppdrag', 'Open to new jobs and projects')}
                </p>
                <p className="max-w-xl mx-auto">
                    {t(
                        'The Branch er avviklet, men flere av oss jobber fortsatt med animasjon og er åpne for nye jobber og oppdrag. Ta gjerne direkte kontakt!',
                        'The Branch has closed, but several of us still work in animation and are open to new jobs and projects. Feel free to get in touch directly!'
                    )}
                </p>
                <LocalizedLink to="/contact" className="inline-flex mt-6 rounded-md text-white items-center justify-center bg-tb-dark px-6" style={{height: "44px"}}>
                    {t('Se kontaktinfo', 'See contact details')}
                </LocalizedLink>
            </div>
        </ContentWrapper>
        <Section className=" mt-8 md:mt-16 block md:flex px-2 avg:px-2 lg:px-32 2xl:px-56 text-tb-dark  justify-center items-end" >
            <div className="team-illustration flex justify-center md:hidden " >
                <img className="team-illustration__title max-h-80 " src={Heisann}  data-aos="fade-in" data-aos-delay="100"/>
                <img src={TeamIllustration} className="max-h-80 mt-4" data-aos="fade-in" />
            </div>
            <div data-aos="fade-up" data-aos-delay="250">
                <p className="text-xl mb-1">{t('Animasjon', 'Animation')}</p>
                <p className="text-2xl mb-10">{t('Kreative filmer', 'Creative films')}</p>
                {t(
                <p className="max-w-lg">
                    The Branch var et produksjonsselskap med fokus på håndtegnet 2D-animasjon,
                    aktivt fra {ACTIVE_YEARS}. Vi jobbet mye med kortfilm og musikkvideo,
                    og hadde en særlig forkjærlighet for å skape morsomme karakterer med tydelig særpreg.
                    <br /><br /><br />
                    Målet var alltid å legge igjen et sterkt inntrykk hos seeren, et som ikke forlater tankene med det første.
                    <br /><br />
                    Selskapet er nå avviklet, men filmene og oppdragene våre ligger fortsatt her.
                    Takk til alle som har sett, delt og samarbeidet med oss!
                </p>,
                <p className="max-w-lg">
                    The Branch was a production company focused on hand-drawn 2D animation,
                    active from {ACTIVE_YEARS}. We worked mostly on short films and music videos,
                    and had a particular fondness for creating funny characters with a distinct personality.
                    <br /><br /><br />
                    Our goal was always to leave a strong impression on the viewer, one that stays with them long after.
                    <br /><br />
                    The company has now closed, but our films and projects are still here.
                    Thank you to everyone who has watched, shared and worked with us!
                </p>
                )}
            </div>
            <div className="team-illustration hidden md:block" >
                <img className="team-illustration__title lg:max-h-80 max-h-56 " src={Heisann}  data-aos="fade-in" data-aos-delay="100"/>
                <img src={TeamIllustration} className="lg:max-h-80 max-h-56 " data-aos="fade-in" />
            </div>
        </Section>
        <ContentWrapper>
            <div className="mt-8 md:mt-32 flex justify-center relative about-video " data-aos="fade-up" data-aos-delay="150">
                <img src={VideoFrame} className="about-video__frame" />
                <iframe ref={videoIframe} className="absolute"  src="https://player.vimeo.com/video/744917874?byline=0&portrait=0&title=0&controls=1&playsinline=1&muted=0&autoplay=0"   frameborder="0" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
            </div>
        </ContentWrapper>
        <ContentWrapper>
            <ClientSection />
                 
        </ContentWrapper>
   
    </div>

    </div>
  </>
}

export default Hero;

/*
    <Section gray className="px-8 lg:px-16 justify-center lg:justify-start flex flex-wrap-reverse items-center lg:justify-between">
        <div className="w-full md:w-1/2">
            <p className="font-bold mb-4">Trenger du animasjon?</p>
            <p>Trenger du animasjon for ditt produkt eller tjeneste? Vi tilbyr info - og reklamefilmer, med flytende bevegelser. Produsert raskt og med høy kvalitet! </p>
        </div>
        <img src={bird_1} style={{height: "300px"}} />
    </Section>
    <Section className="px-8 lg:px-16 justify-center lg:justify-start flex flex-wrap items-center lg:justify-between">
        <img src={bird_2} style={{height: "300px"}} />
        <div className="w-full md:w-1/2">
            <p className="font-bold mb-4">Skreddersydd etter dine ønsker</p>
            <p>Hyrer du oss inn til å produsere animasjonsfilm, samarbeider vi om å finne ut best måte å formidle det du ønsker. </p>
        </div>
    </Section>
    <Section gray className="px-8 lg:px-16 justify-center lg:justify-start flex flex-wrap-reverse items-center lg:justify-between">
        <div className="w-full md:w-1/2">
            <p className="font-bold mb-4">Komunikasjon</p>
            <p>Deretter garanterer vi at vi vil produsere er attraktivt, oversiktlig og skreddersydd produkt av høyeste kvalitet.</p>
            <Link to="/contact">
                <div className="mt-8 flex border rounded-lg  text-white items-center justify-center bg-tb-blue cursor-pointer" style={{height: "40px", width: "130px"}}>Kontakt oss</div>
            </Link>
        </div>
        <img src={bird_3} style={{height: "300px"}} />
    </Section>*/